/**
 * Warna efektif orb: pilihan admin, atau warna tema dashboard bila
 * `followTheme` menyala.
 *
 * Gunanya opsi "ikut tema": kalau palet dashboard diganti nanti, orb ikut
 * berubah tanpa ada yang perlu membuka pengaturan Jenna.
 *
 * Fungsi murni tanpa DOM — diuji langsung dengan `bun:test`.
 */

import { palette } from "@/theme/palette";
import type { AssistantOrbConfig } from "@/types/ai-assistant-orb";

export interface OrbColors {
	from: string;
	to: string;
}

/**
 * Pasangan warna tema per mode. `primary` dipakai sebagai ujung terang dan
 * `bg`/`border` sebagai ujung gelap, sehingga gradiennya selalu punya kontras
 * ke latar di mode mana pun.
 */
const THEME_COLORS: Record<"dark" | "light", OrbColors> = {
	dark: { from: palette.dark.border, to: palette.dark.primary },
	light: { from: palette.light.primary, to: palette.light.info },
};

export function resolveOrbColors(
	config: Pick<AssistantOrbConfig, "colorFrom" | "colorTo" | "followTheme">,
	light: boolean,
): OrbColors {
	if (config.followTheme) return THEME_COLORS[light ? "light" : "dark"];
	return { from: config.colorFrom, to: config.colorTo };
}
